import React from 'react';
import Layout from '@components/Layout';
import ProductList from '@components/ProductList';

const Index = () => {
  return (
    <Layout>
      <ProductList />
    </Layout>
  );
};

export default Index;
